import React from 'react';

function formatDate(dateStr) {
  if (!dateStr) return '—';
  const [y, m, d] = dateStr.slice(0, 10).split('-');
  if (!y || !m || !d) return '—';
  return `${d}/${m}/${y}`;
}

export default function LocationCard({ person, onNewSearch, onComoChegar }) {
  const initials = person.name.split(' ').map(n => n[0]).slice(0, 2).join('').toUpperCase();
  const hasGps = person.latitude != null && person.longitude != null;

  return (
    <div className="location-card">
      <div className="person-avatar">{initials}</div>
      <h2>{person.name}</h2>
      <p className="dates dates-icons">
        {person.birth_date && (
          <span className="date-item birth-date" title="Data de nascimento">
            <svg width="14" height="14" viewBox="0 0 24 24" fill="currentColor" stroke="none">
              <polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2" />
            </svg>
            {formatDate(person.birth_date)}
          </span>
        )}
        {person.death_date && (
          <span className="date-item death-date" title="Data de falecimento">
            <svg width="14" height="14" viewBox="0 0 24 24" fill="currentColor" stroke="none">
              <path d="M10 3h4v5h5v4h-5v9h-4v-9H5V8h5z" />
            </svg>
            {formatDate(person.death_date)}
          </span>
        )}
        {!person.birth_date && !person.death_date && '—'}
      </p>

      <div className="location-details">
        <div className="location-detail-row">
          <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
            <rect x="3" y="3" width="18" height="18" rx="2" ry="2"></rect>
            <line x1="3" y1="9" x2="21" y2="9"></line>
            <line x1="9" y1="21" x2="9" y2="9"></line>
          </svg>
          <span>Quadra {person.block}</span>
        </div>
        {person.sector ? (
          <div className="location-detail-row">
            <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
              <polygon points="12 2 2 7 12 12 22 7 12 2"></polygon>
              <polyline points="2 17 12 22 22 17"></polyline>
              <polyline points="2 12 12 17 22 12"></polyline>
            </svg>
            <span>Setor {person.sector}</span>
          </div>
        ) : null}
        <div className="location-detail-row">
          <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
            <path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0 1 18 0z"></path>
            <circle cx="12" cy="10" r="3"></circle>
          </svg>
          <span>Jazigo {person.number}</span>
        </div>
      </div>

      <div className="location-actions">
        <button
          className="btn-primary"
          onClick={() => {
            if (hasGps && onComoChegar) {
              onComoChegar();
              return;
            }
            const el = document.querySelector('.map-container');
            if (el) el.scrollIntoView({ behavior: 'smooth', block: 'center' });
          }}
        >
          COMO CHEGAR
        </button>
        <button className="btn-secondary" onClick={onNewSearch}>
          NOVA BUSCA
        </button>
      </div>
      {hasGps && (
        <p style={{ fontSize: 12, color: 'var(--texto-secundario)', textAlign: 'center', marginTop: 8 }}>
          Localização GPS disponível — toque em “COMO CHEGAR” para navegação em tempo real.
        </p>
      )}
    </div>
  );
}
